export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f6e046cc0d662503fba0da3e205f7c82983d3dfbd&name=fetchTypeahead!'